import React from 'react';
import { Alert, AlertTitle } from '@mui/material';

/** propose_action's rep actions, as the MCP service names them. */
const ACTION_LABELS = {
  resend_invite: "Resend the resident's invitation",
  send_password_reset: 'Send the resident a password reset',
  update_email: "Change the email on the resident's account",
  waive_late_fee: 'Waive a late fee as a one-time courtesy',
  review_payment: 'Have a rep review a payment',
  contact_pm: 'Have a rep contact the property manager',
  cancel_bulk_enrollment: "Cancel the resident's bulk internet enrollment",
  record_move_out: 'Record a move-out on a residency',
  update_residency_move_out: 'Record a move-out on a residency',
  update_residency_occupancy: 'Change the occupant count on a residency',
  update_residency_billing_settings: 'Change billing settings on a residency',
  charge_correction: 'Correct a charge'
};
const labelOf = action => {
  var _ACTION_LABELS$action;
  const words = action.replace(/_/g, ' ');
  return (_ACTION_LABELS$action = ACTION_LABELS[action]) !== null && _ACTION_LABELS$action !== void 0 ? _ACTION_LABELS$action : words.charAt(0).toUpperCase() + words.slice(1);
};

/** A rep's step Livy proposed in shadow. Information only: no button, so it can never be confirmed from here. */
export function LivyShadowAction(_ref) {
  let action = _ref.action;
  return /*#__PURE__*/React.createElement(Alert, {
    severity: "info",
    variant: "outlined",
    role: "status",
    sx: {
      mt: '12px',
      borderRadius: '10px',
      '& .MuiAlert-message': {
        fontSize: 13
      }
    }
  }, /*#__PURE__*/React.createElement(AlertTitle, {
    sx: {
      fontSize: 13,
      fontWeight: 600
    }
  }, "Proposed, not done"), labelOf(action), ". Livy proposed this step; nothing has changed. A person decides whether to do it.");
}